// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page & layout */
.yYQlRS_TyuxHvNQoH9b_ {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: hidden;
  background: var(--bg-color);
}

.UuiIzxLcHPREbXzxWN5N {
  height: 100%;
  width: 100%;
  border: none;
}

.LYPBCiojMX1WsPF9qLyc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  background: var(--surface-bg-2);
  border-bottom: 1px solid var(--border-color);
  flex-shrink: 0;
  box-shadow: 0 1px 6px rgba(0,0,0,0.22);
}

.NBYnlqlIAIWwUrznfSzE {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--text-color);
  letter-spacing: 0.02em;
}

.Pxmo_hANfR3ZzE1B44kR {
  padding: 8px 16px;
  background: transparent;
  color: var(--text-color);
  border: 1px solid rgba(233, 192, 112, 0.55);
  border-radius: 6px;
  text-decoration: none;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.Pxmo_hANfR3ZzE1B44kR:hover {
  background: var(--surface-bg-2);
  border-color: rgba(233, 192, 112, 0.75);
}

/* Top / bottom sections */
.BLp_O0X6we1obCcjuPxD {
  min-height: 0;
  display: flex;
  flex-direction: column;
  flex: 0 0 70%;
}

.x4FoZnUN31GH4HkGdyaA {
  display: flex;
  flex: 1;
  min-height: 0;
}

.FmWkz5Exd6fHfAhholY6 {
  height: 6px;
  background: var(--border-color);
  cursor: row-resize;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.FmWkz5Exd6fHfAhholY6:hover {
  background: var(--accent-color);
}

.TLAd4YYLNmoi4Dr3MMUe {
  width: 36px;
  height: 3px;
  background: var(--accent-color);
  border-radius: 2px;
}

.KggoCNxzZJxHxy9EY7hV {
  min-height: 0;
  flex: 0 0 30%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0 2px 2px 2px;
}

/* Panels */
.GJylHPK4zeDgv1XBJOFK,
.CwPcmOZCZfkh34he_TXX {
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 8px;
}

.GJylHPK4zeDgv1XBJOFK {
  flex: 0 0 60%;
  padding-right: 4px;
}

.CwPcmOZCZfkh34he_TXX {
  flex: 0 0 40%;
  padding-left: 4px;
}

.KTapAjayJNOgER2KMssC {
  width: 6px;
  background: var(--border-color);
  cursor: col-resize;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}

.KTapAjayJNOgER2KMssC:hover {
  background: var(--accent-color);
}

.pG2b0Ly97OJHea5IlRNh {
  width: 3px;
  height: 36px;
  background: var(--accent-color);
  border-radius: 2px;
}

/* DataGrid on knowledge base: 淡黄色背景，简洁优雅 */
.PyzHcJAEjSFLkQ24IZiC {
  background: var(--surface-bg) !important;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.24);
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.PyzHcJAEjSFLkQ24IZiC > div:first-child { background: var(--surface-bg-2) !important; border-bottom: 1px solid var(--border-color); }

.PyzHcJAEjSFLkQ24IZiC table thead th { background: var(--surface-bg-2) !important; }

.PyzHcJAEjSFLkQ24IZiC table tbody tr { background: var(--surface-bg) !important; }

.PyzHcJAEjSFLkQ24IZiC table tbody tr:hover { background: var(--surface-bg-2) !important; }

/* Cell styling for document list */
.U3vs_xPhahsYmEf9qjh5 {
  font-weight: 600;
  color: var(--text-color);
  font-size: 12px;
}

.SvN0J2sVh9gPsLjjl4Rj {
  color: var(--text-color);
  font-size: 13px;
  line-height: 1.4;
  word-break: break-word;
}

@media (max-width: 768px) {
  .yYQlRS_TyuxHvNQoH9b_ {
    height: 100%;
    overflow: auto;
  }
  .LYPBCiojMX1WsPF9qLyc {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .NBYnlqlIAIWwUrznfSzE { font-size: 14px; }
  .GJylHPK4zeDgv1XBJOFK, .CwPcmOZCZfkh34he_TXX { padding: 4px; }
  .KTapAjayJNOgER2KMssC, .FmWkz5Exd6fHfAhholY6 { display: none; }
  .BLp_O0X6we1obCcjuPxD, .KggoCNxzZJxHxy9EY7hV { flex: 1 1 auto !important; }
  .x4FoZnUN31GH4HkGdyaA { flex-direction: column; }
  .GJylHPK4zeDgv1XBJOFK, .CwPcmOZCZfkh34he_TXX {
    flex: 1 1 auto !important;
    min-height: 220px;
    overflow: visible;
  }
  .KggoCNxzZJxHxy9EY7hV {
    min-height: 260px;
    overflow: visible;
  }
  .PyzHcJAEjSFLkQ24IZiC {
    min-height: 240px;
  }
}
`, "",{"version":3,"sources":["webpack://./components/KnowledgeBase.module.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,4CAA4C;EAC5C,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;EACxB,2CAA2C;EAC3C,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;EAC/B,uCAAuC;AACzC;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,WAAW;AACX;;EAEE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,wCAAwC;EACxC,qCAAqC;EACrC,mBAAmB;EACnB,uCAAuC;EACvC,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,0CAA4B,0CAA0C,EAAE,4CAA4C,EAAE;;AAEtH,uCAAyB,0CAA0C,EAAE;;AAErE,uCAAyB,wCAAwC,EAAE;;AAEnE,6CAA+B,0CAA0C,EAAE;;AAE3E,mCAAmC;AACnC;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;EACA,wBAAe,eAAe,EAAE;EAChC,+CAA0B,YAAY,EAAE;EACxC,+CAA2B,aAAa,EAAE;EAC1C,+CAA8B,yBAAyB,EAAE;EACzD,wBAAY,sBAAsB,EAAE;EACpC;IACE,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Page & layout */\r\n.page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100vh;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  background: var(--bg-color);\r\n}\r\n\r\n.embeddedPage {\r\n  height: 100%;\r\n  width: 100%;\r\n  border: none;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 14px 24px;\r\n  background: var(--surface-bg-2);\r\n  border-bottom: 1px solid var(--border-color);\r\n  flex-shrink: 0;\r\n  box-shadow: 0 1px 6px rgba(0,0,0,0.22);\r\n}\r\n\r\n.headerTitle {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  font-weight: 600;\r\n  color: var(--text-color);\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.backLink {\r\n  padding: 8px 16px;\r\n  background: transparent;\r\n  color: var(--text-color);\r\n  border: 1px solid rgba(233, 192, 112, 0.55);\r\n  border-radius: 6px;\r\n  text-decoration: none;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  transition: background 0.15s, border-color 0.15s;\r\n}\r\n\r\n.backLink:hover {\r\n  background: var(--surface-bg-2);\r\n  border-color: rgba(233, 192, 112, 0.75);\r\n}\r\n\r\n/* Top / bottom sections */\r\n.topSection {\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  flex: 0 0 70%;\r\n}\r\n\r\n.topInner {\r\n  display: flex;\r\n  flex: 1;\r\n  min-height: 0;\r\n}\r\n\r\n.hResizeBar {\r\n  height: 6px;\r\n  background: var(--border-color);\r\n  cursor: row-resize;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.hResizeBar:hover {\r\n  background: var(--accent-color);\r\n}\r\n\r\n.hResizeHandle {\r\n  width: 36px;\r\n  height: 3px;\r\n  background: var(--accent-color);\r\n  border-radius: 2px;\r\n}\r\n\r\n.bottomSection {\r\n  min-height: 0;\r\n  flex: 0 0 30%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  padding: 0 2px 2px 2px;\r\n}\r\n\r\n/* Panels */\r\n.leftPanel,\r\n.rightPanel {\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  padding: 8px;\r\n}\r\n\r\n.leftPanel {\r\n  flex: 0 0 60%;\r\n  padding-right: 4px;\r\n}\r\n\r\n.rightPanel {\r\n  flex: 0 0 40%;\r\n  padding-left: 4px;\r\n}\r\n\r\n.vResizeBar {\r\n  width: 6px;\r\n  background: var(--border-color);\r\n  cursor: col-resize;\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.vResizeBar:hover {\r\n  background: var(--accent-color);\r\n}\r\n\r\n.vResizeHandle {\r\n  width: 3px;\r\n  height: 36px;\r\n  background: var(--accent-color);\r\n  border-radius: 2px;\r\n}\r\n\r\n/* DataGrid on knowledge base: 淡黄色背景，简洁优雅 */\r\n.kbGrid {\r\n  background: var(--surface-bg) !important;\r\n  border: 1px solid var(--border-color);\r\n  border-radius: 10px;\r\n  box-shadow: 0 4px 14px rgba(0,0,0,0.24);\r\n  flex: 1;\r\n  min-height: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.kbGrid > div:first-child { background: var(--surface-bg-2) !important; border-bottom: 1px solid var(--border-color); }\r\n\r\n.kbGrid table thead th { background: var(--surface-bg-2) !important; }\r\n\r\n.kbGrid table tbody tr { background: var(--surface-bg) !important; }\r\n\r\n.kbGrid table tbody tr:hover { background: var(--surface-bg-2) !important; }\r\n\r\n/* Cell styling for document list */\r\n.cellId {\r\n  font-weight: 600;\r\n  color: var(--text-color);\r\n  font-size: 12px;\r\n}\r\n\r\n.cellContent {\r\n  color: var(--text-color);\r\n  font-size: 13px;\r\n  line-height: 1.4;\r\n  word-break: break-word;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .page {\r\n    height: 100%;\r\n    overflow: auto;\r\n  }\r\n  .header {\r\n    padding: 10px 12px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n  .headerTitle { font-size: 14px; }\r\n  .leftPanel, .rightPanel { padding: 4px; }\r\n  .vResizeBar, .hResizeBar { display: none; }\r\n  .topSection, .bottomSection { flex: 1 1 auto !important; }\r\n  .topInner { flex-direction: column; }\r\n  .leftPanel, .rightPanel {\r\n    flex: 1 1 auto !important;\r\n    min-height: 220px;\r\n    overflow: visible;\r\n  }\r\n  .bottomSection {\r\n    min-height: 260px;\r\n    overflow: visible;\r\n  }\r\n  .kbGrid {\r\n    min-height: 240px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `yYQlRS_TyuxHvNQoH9b_`,
	"embeddedPage": `UuiIzxLcHPREbXzxWN5N`,
	"header": `LYPBCiojMX1WsPF9qLyc`,
	"headerTitle": `NBYnlqlIAIWwUrznfSzE`,
	"backLink": `Pxmo_hANfR3ZzE1B44kR`,
	"topSection": `BLp_O0X6we1obCcjuPxD`,
	"topInner": `x4FoZnUN31GH4HkGdyaA`,
	"hResizeBar": `FmWkz5Exd6fHfAhholY6`,
	"hResizeHandle": `TLAd4YYLNmoi4Dr3MMUe`,
	"bottomSection": `KggoCNxzZJxHxy9EY7hV`,
	"leftPanel": `GJylHPK4zeDgv1XBJOFK`,
	"rightPanel": `CwPcmOZCZfkh34he_TXX`,
	"vResizeBar": `KTapAjayJNOgER2KMssC`,
	"vResizeHandle": `pG2b0Ly97OJHea5IlRNh`,
	"kbGrid": `PyzHcJAEjSFLkQ24IZiC`,
	"cellId": `U3vs_xPhahsYmEf9qjh5`,
	"cellContent": `SvN0J2sVh9gPsLjjl4Rj`
};
export default ___CSS_LOADER_EXPORT___;
